<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body {
  margin: 0;
  background: #f2f4f7;
}
#app {
  min-height: 100vh;
}
</style>
